import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Subject, takeUntil } from 'rxjs';
import { SnackbarComponent } from 'src/app/components/snackbar/snackbar.component';
import { PurchasingService } from 'src/app/services/purchasing.service';

@Component({
  selector: 'app-inbound-stock-tooltip',
  templateUrl: './inbound-stock-tooltip.component.html',
  styleUrls: ['./inbound-stock-tooltip.component.scss']
})
export class InboundStockTooltipComponent implements OnInit,OnDestroy {
  breakdown: StockBreakdown[];
  private destroy$ = new Subject<void>();
  
  constructor(
    private purchasingService: PurchasingService,
    @Inject(MAT_DIALOG_DATA) public data,
    public dialogRef: MatDialogRef<InboundStockTooltipComponent>,
    private snackBar: MatSnackBar
  ) {}

  ngOnInit(): void {
    this.purchasingService.GetProductPoInfo(this.data).pipe(takeUntil(this.destroy$)).subscribe({
      next: (res: StockBreakdown[]) => {
        this.breakdown = res;
      },
      error: (err) => {
        this.snackBar.openFromComponent(SnackbarComponent, {
          duration: 3000,
          horizontalPosition: 'center',
          data: {
            title: err.error?.error[0],
            action: 'Dismiss',
            type: 'error',
          },
        });
      }
    })
   }

  ngOnDestroy() {
      this.destroy$.next();
      this.destroy$.unsubscribe();
    }
  }
interface StockBreakdown {
  purchaseOrderId: number;
  expectedOn: string;
  outstandingQty: number;
}

